export * from './cartorio-controller.service';
export * from './controller.module';
export * from './usuario-controller.service';
export * from './pergunta-cartorio-controller.service';
export * from './atendimento-controller.service';
